import React from 'react';

export function SourceBlock({ url, qrSrc, className = '' }) {
  if (!url) return null;

  return (
    <div className={`ds-source-block ${className}`.trim()}>
      <span className="ds-source-block__label">Receta Original</span>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="ds-source-block__link"
      >
        {url}
      </a>
      {qrSrc ? <img src={qrSrc} alt="Código QR de la receta original" className="ds-source-block__qr" /> : null}
    </div>
  );
}

export default SourceBlock;
